import resolveConfig from "tailwindcss/resolveConfig"
import defaultConfig from "tailwindcss/defaultConfig"
import tailwindConfig from "../../tailwind.config.js"

export const twDefaultConfig = resolveConfig(defaultConfig)
export const twCustomConfig = resolveConfig(tailwindConfig)
